import buildSubjectApiPath from '@Application/Subjects/buildSubjectApiPath';
import type * as React from 'react';
import type MarkWorkflowRunHandled from '@Application/WorkflowRuns/Handling/Commands/MarkWorkflowRunHandled';
import workflowRunHandled, {
	type WorkflowRunHandledAction,
} from '@Application/WorkflowRuns/Handling/Actions/workflowRunHandled';
import workflowRunHandlingFailed, {
	type WorkflowRunHandlingFailedAction,
} from '@Application/WorkflowRuns/Handling/Actions/workflowRunHandlingFailed';
import type { FacilityWorkflowRunPayload } from '@Application/WorkflowRuns/FacilityWorkflowRuns/Actions/facilityWorkflowRunsFetched';
import { put } from '@Domain/Api';
import extractMessages from '@Infra/FetchLib/ApiError/extractMessages';

type Actions = WorkflowRunHandledAction | WorkflowRunHandlingFailedAction;

export default (command: MarkWorkflowRunHandled) => {
	return async (dispatch: React.Dispatch<Actions>): Promise<Actions> => {
		try {
			const payload = await put<FacilityWorkflowRunPayload>(
				`${buildSubjectApiPath(command.facilityId, command.subject)}/workflow-runs/${command.runId}/handling`,
				{},
			);

			const action = workflowRunHandled(payload, command.facilityId, command.subject.subjectId);
			dispatch(action);
			return action;
		} catch (error) {
			const action = workflowRunHandlingFailed(extractMessages(error));
			dispatch(action);
			return Promise.reject(action);
		}
	};
};
